import { GetPermissionList } from '@/brain/record/permission'
import { GetOccupationList } from '@/brain/record/occupation'
import { GetStageList } from '@/brain/record/stage'

const ListPermissions = () => {
  return new Promise((resolve, reject) => {
    GetPermissionList()
    .then((result) => {
      resolve(result.map((pData) => { return { text: pData.name, value: pData._id } }))
    })
  })
}

const ListOccupations = () => {
  return new Promise((resolve, reject) => {
    GetOccupationList()
    .then((result) => {
      resolve(result.map((pData) => { return { text: pData.name, value: pData._id } }))
    })
  })
}

const ListStages = async () => {
  const stageList = await GetStageList()
  const mappedStageList = stageList.map(item => ({ text: item.name, value: item._id }))
  return mappedStageList
}

export {
  ListPermissions,
  ListOccupations,
  ListStages
}



// WEBPACK FOOTER //
// ./src/view/record/user/NewUserHelper.js